//Taost mesages codes
export const VALIDATORS={
    MAX_PHONE_NUMBER_PATTERN : '^(\\+1\\s?)?\\(\\d{3}\\)\\s\\d{3}-\\d{4}$',
    MAX_EMAIL_CHAREACTER_ALLOWED : '^.{0,255}$',
}